<template>
    <div v-loading="busy" class="align-self-stretch flex-fill d-flex">
        <placeholder
                v-if="hasError"
                :message="items"
                class="text-danger"
        ></placeholder>
        <slot
                v-else-if="messagesNotGenerated"
                name="not-generated"
        ></slot>
        <div v-else class="px-2 pt-2 align-self-stretch flex-fill d-flex flex-column">
            <div class="d-flex mb-2 search-bar">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar-input"
                ></input-debounced>
                <div class="d-flex">
                    <button class="btn btn-purple ml-1" @click="refresh">
                        <i class="fas fa-sync" :class="{'fa-spin': busy}"></i>
                    </button>
                </div>
            </div>
            <placeholder
                    v-if="hasNoItems"
                    class="text-secondary"
                    message="No Items"
            ></placeholder>
            <div
                    v-else
                    class="align-self-stretch flex-fill items"
            >
                <list-item
                        v-for="(item, index) in items"
                        :key="getItemKey(index)"
                        :item="item"
                        @select="onSelect"
                        @edit="onEdit"
                        :is-selected="isSelected(item)"
                ></list-item>
            </div>
        </div>
    </div>
</template>

<script>
  import ListItem from './message-list-item';
  import Placeholder from './placeholder';
  import {addQueryParams} from "../../libs/url";

  export default {
    components: {
      ListItem,
      Placeholder,
    },

    props: {
      campaign: Object,
    },

    data() {
      return {
        search: null,
        filters: {},
        items: [],
        current: null,
        cancelToken: null,
      };
    },

    computed: {
      /**
       * @return {string|null}
       */
      indexUrl() {
        return _.get(this.campaign, 'messageIndexUrl', null);
      },

      /**
       * @return {string|null}
       */
      urlWithFilters() {
        return addQueryParams(this.indexUrl, this.filters);
      },

      /**
       * @return {boolean}
       */
      hasError() {
        return _.isString(this.items);
      },

      /**
       * @return {boolean}
       */
      hasNoItems() {
        return Boolean(_.isArray(this.items) && _.isEmpty(this.items));
      },

      /**
       * @return {boolean}
       */
      messagesNotGenerated() {
        return this.items === null;
      },

      /**
       * @return {boolean}
       */
      busy() {
        return Boolean(this.cancelToken);
      },
    },

    watch: {
      urlWithFilters() {
        this.refresh();
      },

      search(value) {
        const filters = _.omit(this.filters, ['search']);
        if (value) {
          filters.search = value;
        }
        this.filters = filters;
      },
    },

    methods: {
      refresh() {
        this.cancelToken && this.cancelToken.cancel();
        this.cancelToken = axios.CancelToken.source();

        axios.get(this.urlWithFilters, {
          cancelToken: this.cancelToken.token,
        })
          .then(this.onLoadSuccess)
          .catch(this.onLoadError)
          .then((isCancelled = false) => {
            if (!isCancelled) {
              this.cancelToken = null;
            }
          });
      },

      /**
       * @param {array} data
       */
      onLoadSuccess({data: {data}}) {
        this.items = data;
        this.emitHasCachedPreview(_.isArray(data));
      },

      /**
       * @param {object} error
       */
      onLoadError(error) {
        if (axios.isCancel(error)) {
          return true;
        }

        const {response: {status, data: {message}}} = error;
        if (message) {
          this.items = message;
        } else {
          this.items = 'Messages loading error';
        }
      },

      /**
       * @param index
       * @return {string}
       */
      getItemKey(index) {
        return String(_.get(this.campaign, 'model.id', '')) + index;
      },

      /**
       * @param {object} item
       */
      onSelect(item) {
        this.current = item;
      },

      /**
       * @param {object} item
       * @return {boolean}
       */
      isSelected(item) {
        return item === this.current;
      },

      /**
       * @param {string} url
       * @event show-edit-message-list-item-dialog
       */
      onEdit({url}) {
        eventBus.$emit('show-edit-message-list-item-dialog', url);
      },

      /**
       * @param {boolean} value
       */
      emitHasCachedPreview(value) {
        this.$emit('cached-preview-checked', value);
      },
    },

    mounted() {
      this.refresh();
    }
  }
</script>
